<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <g>
    <path class="cls-4" d="m77.24,16.78v8.12H12.76v-8.12c0-2.21,1.81-4.02,4.03-4.02h56.42c2.21,0,4.03,1.81,4.03,4.02Z"/>
    <path class="cls-4" d="m78.39,26.06H11.61v-9.27c0-2.85,2.32-5.17,5.18-5.17h56.42c2.85,0,5.18,2.32,5.18,5.17v9.27Zm-64.48-2.3h62.17v-6.97c0-1.58-1.29-2.87-2.88-2.87H16.79c-1.59,0-2.88,1.29-2.88,2.87v6.97Z"/>
  </g>
  <path class="cls-5" d="m73.21,78.39H16.79c-2.85,0-5.18-2.32-5.18-5.18V23.76h66.78v49.46c0,2.85-2.32,5.18-5.18,5.18ZM13.91,26.06v47.15c0,1.59,1.29,2.88,2.88,2.88h56.42c1.59,0,2.88-1.29,2.88-2.88V26.06H13.91Z"/>
  <rect class="cls-5" x="54.6" y="24.91" width="2.3" height="52.33"/>
  <rect class="cls-5" x="33.1" y="24.91" width="2.3" height="52.33"/>
  <g>
    <line class="cls-2" x1="12.76" y1="42.35" x2="77.24" y2="42.35"/>
    <rect class="cls-5" x="12.76" y="41.2" width="64.48" height="2.3"/>
  </g>
  <g>
    <line class="cls-2" x1="12.76" y1="59.79" x2="77.24" y2="59.79"/>
    <rect class="cls-5" x="12.76" y="58.64" width="64.48" height="2.3"/>
  </g>
  <g>
    <circle class="cls-1" cx="45" cy="51.13" r="16.49"/>
    <path class="cls-2" d="m45,68.78c-9.73,0-17.64-7.91-17.64-17.64s7.91-17.64,17.64-17.64,17.64,7.91,17.64,17.64-7.91,17.64-17.64,17.64Zm0-32.98c-8.46,0-15.34,6.88-15.34,15.34s6.88,15.34,15.34,15.34,15.34-6.88,15.34-15.34-6.88-15.34-15.34-15.34Z"/>
  </g>
  <path class="cls-3" d="m32.21,57.71c-.14,0-.28-.05-.39-.16-.22-.22-.22-.57,0-.78l5.25-5.25c.19-.19.48-.22.7-.07l3.6,2.36,7.1-8.53c.1-.12.24-.19.39-.2.15,0,.3.04.41.15l4.03,3.75,2.95-1.57c.27-.14.61-.04.75.23s.04.61-.23.75l-3.3,1.75c-.21.11-.46.08-.64-.08l-3.89-3.62-7.04,8.46c-.18.22-.49.26-.73.11l-3.64-2.38-4.93,4.93c-.11.11-.25.16-.39.16Z"/>
  <circle class="cls-1" cx="41.33" cy="54.21" r="1.14"/>
  <path class="cls-5" d="m41.33,55.72c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51,1.51.68,1.51,1.51-.68,1.51-1.51,1.51Zm0-2.28c-.43,0-.77.35-.77.77s.35.77.77.77.77-.35.77-.77-.35-.77-.77-.77Z"/>
  <circle class="cls-1" cx="48.96" cy="45.94" r="1.14"/>
  <path class="cls-5" d="m48.96,47.45c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51,1.51.68,1.51,1.51-.68,1.51-1.51,1.51Zm0-2.28c-.43,0-.77.35-.77.77s.35.77.77.77.77-.35.77-.77-.35-.77-.77-.77Z"/>
  <circle class="cls-1" cx="53.41" cy="49.64" r="1.14"/>
  <path class="cls-5" d="m53.41,51.15c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51,1.51.68,1.51,1.51-.68,1.51-1.51,1.51Zm0-2.28c-.43,0-.77.35-.77.77s.35.77.77.77.77-.35.77-.77-.35-.77-.77-.77Z"/>
  <circle class="cls-1" cx="37.46" cy="51.91" r="1.14"/>
  <path class="cls-5" d="m37.46,53.42c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51,1.51.68,1.51,1.51-.68,1.51-1.51,1.51Zm0-2.28c-.43,0-.77.35-.77.77s.35.77.77.77.77-.35.77-.77-.35-.77-.77-.77Z"/>
  <circle class="cls-1" cx="56.84" cy="47.62" r="1.14"/>
  <path class="cls-5" d="m56.84,49.14c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51,1.51.68,1.51,1.51-.68,1.51-1.51,1.51Zm0-2.28c-.43,0-.77.35-.77.77s.35.77.77.77.77-.35.77-.77-.35-.77-.77-.77Z"/>
</svg>
</template>

<script>
export default {
    name: "PerformanceTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #b9e0d1;
  }
  .cls-4 {
    fill: #115c72;
  }
  .cls-5 {
    fill: #59c5c7;
  }
</style>
